import React, { FunctionComponent } from 'react'
import { has } from 'lodash'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import Workout, { WorkoutProps } from 'components/workout'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

import { workoutWrapper } from './index.module.scss'

interface ContentfulWorkoutStepGraphQLResult {
  __typename: 'ContentfulWorkoutStep'
  text: string
}

interface ContentfulArbitraryEmbeddedCodeGraphQlResults {
  type: string
  fields: { iframeContent: { relativePath: string; includedUrls: string[] } }
}

interface ContentfulExerciseGraphQLResult {
  __typename: 'ContentfulExercise'
  name: string
  repetitions: number
  secondsOfWork: number
  secondsOfRest: number
  image: ContentfulArbitraryEmbeddedCodeGraphQlResults
}

export interface RTFContentfulWorkoutGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulWorkout
  calories: number
  exercises: (
    | ContentfulWorkoutStepGraphQLResult
    | ContentfulExerciseGraphQLResult
  )[]
}

type ContentfulWorkoutBlockProps = WorkoutProps & RTFBlockComponentProps

const ContentfulWorkoutBlock: FunctionComponent<ContentfulWorkoutBlockProps> = ({
  calories,
  exercises,
}) => {
  return (
    <Workout
      calories={calories}
      exercises={exercises}
      className={workoutWrapper}
    />
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulWorkoutBlock,
  isValid: ({ exercises }) =>
    !!exercises &&
    !!(exercises as unknown[]).length &&
    (exercises as unknown[]).some((exercise) =>
      has(exercise, 'image.fields.iframeContent.relativePath')
    ),
}

export default componentExport
